module.exports = __webpack_public_path__ + "static/media/backpack.7929e4f3.svg";